import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from '../../../../redux/store/store';

const ProgressWindow = () => {
  const { jobId, progress } = useSelector((state) => state.progress);

  useEffect(() => {
    if (jobId) {
      const eventSource = new EventSource(
        '/api/prospectDriver/progress/' + jobId
      );

      eventSource.onmessage = (event) => {
        const { progress } = JSON.parse(event.data);
        actions.progress.setProgress(progress);

        if (progress === 100) {
          actions.progress.setIsProcessComplete(true);
          setTimeout(() => {
            actions.progress.resetProgress();
          }, 2000);
        }
      };

      eventSource.onerror = (err) => {
        console.error('Error receiving progress updates', err);
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    }
  }, [jobId]);

  if (!jobId) return null;

  return (
      <div style={styles.container}>
        <p style={styles.text}>Import Progress: {progress}%</p>
        <div style={styles.progressBarContainer}>
          <div style={{ ...styles.progressBar, width: `${progress}%` }} />
        </div>
      </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
    width: '300px',
    textAlign: 'center',
    padding: '10px 12px',
    backgroundColor: '#ffffff',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
  },
  progressBarContainer: {
    width: '100%',
    height: '10px',
    backgroundColor: '#e0e0e0',
    borderRadius: '5px',
    overflow: 'hidden',
    marginBottom: '10px'
  },
  progressBar: {
    height: '100%',
    backgroundColor: '#3396f3',
    transition: 'width 0.3s ease'
  },
  text: {
    marginBottom: '5px',
    fontSize: '14px',
    color: '#333'
  }
};

export default ProgressWindow;
